module.exports = "<aside class=\"al-sidebar\" sidebarResize>\n  <ba-menu [menuHeight]=\"menuHeight\"\n           [sidebarCollapsed]=\"isMenuCollapsed\"\n           (expandMenu)=\"menuExpand()\"></ba-menu>\n</aside>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baSidebar/baSidebar.html
// module id = 794
// module chunks = 14